<template>
  <v-container fluid>
    <div class="row">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <ListTransfers />
      </v-col>
    </div>
  </v-container>
</template>

<script>
import ListTransfers from '@/views/transfer/components/ListTransfers'

export default {
  name: 'Transfer',
  components: { ListTransfers },
}
</script>